import { allObjectValuesEmpty } from "./allObjectValuesEmpty"

function formatDate(date) {
    const [month, day, year] = date.split("/")
    return `${year}-${month}-${day}`
}

export function createRansackParams(filters) {
    let queryParams = "?"

    if (!allObjectValuesEmpty(filters)) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value === "" || value === null || value === undefined) return

            if ((key.endsWith("_gteq") || key.endsWith("_lteq")) && typeof value === "string" && value.includes("/")) {
                value = formatDate(value)
            }

            queryParams += `q[${key}]=${encodeURIComponent(value)}&`
        })
    }

    return queryParams
}
